import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';
import { loggerService } from 'shared/lib/logger';

import { getRecentlyVisitedSvcUrl } from './constants';
import { RecentlyVisitedLocation } from './types';

export const recentlyVisitedSvcApi = createApi({
  reducerPath: 'recently-visited-svc',
  baseQuery: baseQuery(getRecentlyVisitedSvcUrl),
  endpoints: (builder) => ({
    getRecentlyVisitedLocations: builder.query<
      RecentlyVisitedLocation[],
      number | undefined
    >({
      query: (limit) => {
        const limitQueryParam = limit !== undefined ? `?limit=${limit}` : '';

        return `v1/recently-visited-location${limitQueryParam}`;
      },
      async onQueryStarted(code, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (e) {
          loggerService.logError('Recently visited locations loading error', e);
        }
      },
    }),
  }),
});

export const { useGetRecentlyVisitedLocationsQuery } = recentlyVisitedSvcApi;
